module.exports = __webpack_public_path__ + "static/media/shaded-relief.13875fd8.svg";